<script>
import BaseCheckbox from '@/components/_base-checkbox.vue'
import BaseChip from '@/components/_base-chip.vue'
import CandidateImage from '@/components/candidate/candidate-image.vue'
import BookingStatusLabel from '@components/booking/booking-status-label.vue'
import { BookingFilters } from '@/shared/constants/booking/list/BookingFilters'

export default {
  name: 'FilterPanelItem',
  components: {
    BaseCheckbox,
    BaseChip,
    CandidateImage,
    BookingStatusLabel,
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    item: { type: Object, required: true },
    index: { type: Number, required: true },
    selectedFilter: { type: Number, required: true },
    valueKey: { type: String, required: true },
    labelKey: { type: [Array, String], required: true },
    name: { type: String, required: true },
    modelValue: { type: Array, required: true },
  },
  emits: ['update:modelValue'],
  computed: {
    isStatus() {
      return this.selectedFilter === BookingFilters.status.id
    },
    isEducator() {
      return this.selectedFilter === BookingFilters.educator.id
    },
    isClassification() {
      return this.selectedFilter === BookingFilters.classification.id
    },
    isCertification() {
      return this.selectedFilter === BookingFilters.certification.id
    },
    itemClass() {
      return this.isStatus
        ? 'mb-1 py-2 filter-sub-option'
        : `py-3 ${this.name}-options filter-sub-option d-flex align-center`
    },
    itemStyle() {
      return this.isEducator
        ? { display: 'flex', alignItems: 'self-start' }
        : {}
    },
    label() {
      return Array.isArray(this.labelKey)
        ? this.labelKey.map((k) => this.item[k]).join(' ')
        : this.item[this.labelKey]
    },
    chipVariant() {
      return this.index % 2 === 0 ? 'blue' : 'purple'
    },
  },
  methods: {
    handleSelectionChange(newValue) {
      this.$emit('update:modelValue', newValue)
    },
  },
}
</script>

<template>
  <div :class="itemClass" :style="itemStyle">
    <BaseCheckbox
      :model-value="modelValue"
      :value="item[valueKey]"
      sm
      custom-class="custom-checkbox me-3"
      @update:modelValue="handleSelectionChange"
    >
      <BookingStatusLabel
        v-if="isStatus"
        :class="['status-cell', 'status-label', item[valueKey]]"
        :status="$t(`general.${item[valueKey]}`)"
      />
      <div v-else-if="isEducator" class="candidate-wrapper flex items-center">
        <CandidateImage
          :id="item[valueKey]"
          :first-name="item.firstName"
          :last-name="item.lastName"
          size="sm"
        />
        <span class="educator-name">{{ label }}</span>
      </div>
      <BaseChip
        v-else-if="isClassification"
        :variant="chipVariant"
        :title="label"
      />
      <BaseChip
        v-else-if="isCertification"
        :variant="chipVariant"
        :title="label"
      />
      <span v-else :class="name">
        {{ label }}
      </span>
    </BaseCheckbox>
  </div>
</template>
